import { Link } from 'react-router'
import { textOn, type LogoRailItem } from '@carouselgg/nexus/logo-rail'
import styles from './MobileLogoStrip.module.css'

export interface MobileLogoStripProps {
  /** Your teams, the orgs you run, the orgs you're in (see railGroups); a thin break between groups. */
  groups: LogoRailItem[][]
  onNavigate?: () => void
  className?: string
}

/**
 * The logo rail on a phone: a sideways strip of your teams and orgs at the top
 * of the drawer, big enough to tap, each named underneath.
 */
export function MobileLogoStrip({ groups, onNavigate, className }: MobileLogoStripProps) {
  const tiles = groups.flat()
  if (tiles.length === 0) return null
  return (
    <nav className={className ? `${styles.wrap} ${className}` : styles.wrap} aria-label="Your teams and organizations">
      <span className={styles.label}>Your teams & orgs</span>
      <ul className={styles.strip}>
        {groups.filter((g) => g.length > 0).flatMap((group, gi) => [
          ...(gi > 0 ? [<li key={`break-${gi}`} className={styles.break} aria-hidden="true" />] : []),
          ...group.map((t) => (
          <li key={t.id}>
            <Link
              to={t.to}
              className={t.active ? `${styles.tile} ${styles.active}` : styles.tile}
              aria-current={t.active ? 'page' : undefined}
              onClick={onNavigate}
            >
              <span className={styles.logoWrap}>
                {t.logoUrl
                  ? <img src={t.logoUrl} alt="" className={styles.logo} />
                  : (
                    <span
                      className={`${styles.logo} ${styles.initial}`}
                      style={t.color && textOn(t.color) ? { background: t.color, color: textOn(t.color), borderColor: 'transparent' } : undefined}
                      aria-hidden="true"
                    >
                      {t.initials || t.label.charAt(0).toUpperCase()}
                    </span>
                  )}
                {t.badge && <span className={styles.badge} aria-hidden="true">{t.badge}</span>}
              </span>
              <span className={styles.name}>{t.label}</span>
            </Link>
          </li>
          )),
        ])}
      </ul>
    </nav>
  )
}
